import { yn } from "@-/com.npmjs.yn";

/**
 * Whether this build opted out of Skia (`EXPO_PUBLIC_DISABLE_SKIA_CHARTS`, set only by the Maestro
 * APK profile). Skia renders through the Graphite backend, which aborts the whole process on a
 * GPU-less CI emulator, so the welcome screen shows `WelcomeGalaxyStaticFallback` instead. Read at
 * call time rather than module load so tests can flip it.
 */
export function isWelcomeGalaxySkiaDisabled(): boolean {
  return yn(process.env.EXPO_PUBLIC_DISABLE_SKIA_CHARTS, { default: false });
}
